import Product from './Product';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { selectBrokerProducts } from '../../../../store/selectors/brokerProducts';
import { useSelector } from 'react-redux';
import { setProductsArray } from './helpers';

const Grid = () => {
  const { formatMessage } = useIntl();
  const brokerProducts = useSelector(selectBrokerProducts);

  return (
    <Fragment>
      <div className='products__header'>
        <h2 className='products__header--title'>
          {formatMessage({
            id: 'Integrations',
          })}
        </h2>
        <h3 className='products__header--subtitle'>
          {formatMessage({
            id: 'Select product',
          })}
        </h3>
      </div>

      <div className='grid-container'>
        {setProductsArray(brokerProducts, formatMessage).map((product, index) => (
          <div className='grid' key={product?.name}>
            <div className='grid-cell'>
              <Product key={index} product={product} />
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default Grid;
